"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneRepair = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var GeneRepair = (function (_super) {
    __extends(GeneRepair, _super);
    function GeneRepair() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.GENE_REPAIR,
            tags: [Tags_1.Tags.SCIENCE],
            cost: 12,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tag(Tags_1.Tags.SCIENCE, 3); }),
            metadata: {
                cardNumber: '091',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) { return b.production(function (pb) { return pb.megacredits(2); }); }),
                description: 'Requires 3 science tags. Increase your M€ production 2 steps.',
                victoryPoints: 2,
            },
        }) || this;
    }
    GeneRepair.prototype.play = function (player) {
        if (player.getTagCount(Tags_1.Tags.SCIENCE) < 3) {
            throw 'Requires 3 science tags.';
        }
        player.addProduction(Resources_1.Resources.MEGACREDITS, 2);
        return undefined;
    };
    GeneRepair.prototype.getVictoryPoints = function () {
        return 2;
    };
    return GeneRepair;
}(Card_1.Card));
exports.GeneRepair = GeneRepair;
//# sourceMappingURL=GeneRepair.js.map